import s from './index.module.css';

export function Loader({width = 48, height = 48}) {
    return (
        <span 
            className={s.loader} 
            style={{
                width: width + 'px', 
                height: height + 'px'
            }}
        ></span>
    );
}